import { Head, Link } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"

type ListingRef = { id: number; day_number: number }
type MonthGroup = { month_number: number; month_name: string; listings: ListingRef[] }

export default function DailyListingsIndex({ months }: { months: MonthGroup[] }) {
  return (
    <>
      <Head title="Daily Listings — Admin">
        <meta name="robots" content="noindex" />
      </Head>
      <AdminShell>
        <h1 className="mb-6">Daily Listings</h1>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
          {months.map((m) => (
            <div key={m.month_number}>
              <h2 className="text-sm font-semibold text-stone-500 uppercase tracking-wider mb-2">
                {m.month_name}
              </h2>
              <div className="grid grid-cols-7 gap-0.5">
                {m.listings.map((l) => (
                  <Link
                    key={l.id}
                    href={`/admin/daily_listings/${l.id}`}
                    className="flex items-center justify-center h-7 w-7 rounded text-xs font-medium text-stone-700 dark:text-stone-300 hover:bg-amber-100 dark:hover:bg-amber-900/40 hover:text-amber-700 dark:hover:text-amber-300 transition-colors no-underline"
                    title={`${m.month_name} ${l.day_number}`}
                  >
                    {l.day_number}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </AdminShell>
    </>
  )
}
